import React from "react";
import { tdStyles } from "../../common/styles";
import { classNameForValidationErrors } from "../../common/components/componentUtils";
import FxInstrument from "./FxInstrument";
import Price from "./Price";
import Direction from "./Direction";
import Derivative from "./Derivative";
import RemoveButton from "./RemoveButton";

const FxRecommendationLeg = (props) => (
    <tr>
        <td style={tdStyles}>
            <Direction {...props.direction} />
        </td>
        <td style={tdStyles}>
            <FxInstrument {...props.instrument}
                          className={ classNameForValidationErrors(props.instrument) }/>
        </td>
        <td style={tdStyles}>
            <Derivative derivativeDescription={props.derivativeDescription}
                        placeholder="Strike, Expiry etc."
                        className={ classNameForValidationErrors(props.derivativeDescription) } />
        </td>
        <td style={tdStyles}>
            <Price {...props.suppliedPrice}
                   className={`x-market-price ${classNameForValidationErrors(props.suppliedPrice)}`} />
        </td>
        <td style={tdStyles}>
            <Price {...props.targetPrice} />
        </td>
        <td>
            <RemoveButton onClick={props.onRemoveLeg} />
        </td>
    </tr>
);

export default FxRecommendationLeg;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/FxRecommendationLeg.js
 **/